import ArrowBack from '@mui/icons-material/ArrowBackIos';
import { Formik } from 'formik';
import React from 'react';
import { PhoneInput } from 'react-international-phone';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LOCAL_STORAGE_KEYS } from '../../../../global/const';
import FormikPlaceSearch from '../../../components/UI/FormikPlaceSearch';
import TextInput from '../../../components/UI/TextInput';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { POST } from '../../../services/rest.service';
import FamilyCreateSchema from '../../../validationSchema/families/FamilyCreateSchema';

const FamilyForm = (props) => (
  <Formik
    initialValues={{
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      mobile_number: '',
      location: {},
    }}
    onSubmit={(values) => {
      props.onSubmit(values);
    }}
    validationSchema={FamilyCreateSchema}
  >
    {(renderProps) => {
      const { values, touched, errors, handleChange, handleBlur, setFieldValue, handleSubmit } = renderProps;

      return (
        <form className="row" onSubmit={handleSubmit}>
          <TextInput
            label={'First Name'}
            labelClasses={'text-uppercase'}
            placeholder={'Please enter first name'}
            size={'col col-lg-6'}
            value={values.first_name}
            error={touched.first_name && errors.first_name}
            onChange={handleChange}
            onBlur={handleBlur}
            name={'first_name'}
            id={'first_name'}
          />
          <TextInput
            label={'Last Name'}
            labelClasses={'text-uppercase'}
            size={'col col-lg-6'}
            placeholder={'Please enter last name'}
            error={touched.last_name && errors.last_name}
            value={values.last_name}
            onChange={handleChange}
            onBlur={handleBlur}
            name={'last_name'}
            id={'last_name'}
          />
          <TextInput
            label={'Email'}
            labelClasses={'text-uppercase'}
            size={'col col-lg-6'}
            placeholder={'Please enter email'}
            type={'email'}
            error={touched.email && errors.email}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            name={'email'}
            id={'email'}
          />
          <TextInput
            label={'Password'}
            name="password"
            id="password"
            labelClasses={'text-uppercase'}
            size={'col col-lg-6'}
            placeholder={'Please enter temporary password'}
            type={'password'}
            error={touched.password && errors.password}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <div className={'form-group col col-lg-6'}>
            <label className={'form-label text-uppercase'}>Mobile Number</label>
            <PhoneInput defaultCountry="us" value={values.mobile_number} onChange={(e, phone) => setFieldValue('mobile_number', phone.inputValue)} onBlur={handleBlur} />
          </div>
          <FormikPlaceSearch
            id={'location'}
            name={'location'}
            label={'Location'}
            labelClasses={'text-uppercase'}
            size={'col col-lg-6'}
            onChange={(e) => {
              const place = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.LOCATION));
              setFieldValue('location', place);
              setTimeout(() => {
                localStorage.removeItem(LOCAL_STORAGE_KEYS.LOCATION);
              }, 100);
            }}
            placeholder={'Please enter location'}
          />

          <div className="form-group col-12 mt-3">
            <button type="submit" className="btn btn-primary btn-lg" onClick={handleSubmit}>
              Create
            </button>
          </div>
        </form>
      );
    }}
  </Formik>
);

const FamilyCreate = () => {
  const dispatch = useDispatch();
  const skills = useSelector((state) => state.skills);
  const navigate = useNavigate();

  const doCreateFamilyAccount = async (formData) => {
    const payload = {
      ...formData,
      type: 'Family',
    };
    dispatch(showLoading('Creating Account...'));
    try {
      await POST('/admin/family/add', payload);
      toast.success('Family account created!');
      navigate('/admin/family/list');
      dispatch(hideLoading());
    } catch (err) {
      toast.error(err.message);
      dispatch(hideLoading());
    }
  };

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-lg-8 mb-5">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h3 className="h6 text-uppercase mb-0">
                  <a href="#!" onClick={() => navigate(-1)}>
                    <ArrowBack />
                  </a>
                  Add Family Account
                </h3>
                <small className="text-danger">*All fields are required</small>
              </div>
              <div className="card-body">
                <FamilyForm onSubmit={doCreateFamilyAccount} skills={skills} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FamilyCreate;
